module.exports = __webpack_public_path__ + "assets/img/yunzhuji_23.e5999a1e.gif";